import { Component, OnInit } from '@angular/core';

import { environment } from '@ap/http';

import { NavMenuService, NavItem } from '@library/modules/menu';
import { AdminAccountService } from '../admin/account/admin-account.service';
export const MenuItems: NavItem[] = [
   { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
   // { label: 'Activity Feed', path: '/activityfeed', icon: 'activityfeed' },
   { label: 'Admin', path: '/admin', icon: 'admin' },
];

@Component({
   selector: 'app-menu',
   templateUrl: './menu.component.html',
   styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
   environment = environment;

   viewport: number;

   constructor(
      private nav: NavMenuService,
      private adminAccountService: AdminAccountService,
   ) {}

   ngOnInit(): void {
      this.nav.load( MenuItems, this.adminAccountService );
      this.nav.showTracking = false;
      this.nav.title = 'agent portal';
   }
}
